// extracted by mini-css-extract-plugin
export default {"fs":"_69c38fdb61 _15b434203b"};